<template>
  <div class="row">


    <div class="col-xl-1 col-lg-2 col-md-3">
    </div>
    <div class="col-xl-10 col-lg-8 col-md-6">
      <edit-profile-form>

      </edit-profile-form>
    </div>
    <div class="col-xl-1 col-lg-2 col-md-3">
    </div>


    <!-- OG content


    <div class="col-lg-4 col-md-5">
      <user-card>

      </user-card>
      <members-card>

      </members-card>
    </div>
    <div class="col-lg-8 col-md-7">
      <edit-profile-form>

      </edit-profile-form>
    </div>


    END -->


  </div>
</template>
<script>
  import EditProfileForm from './UserProfile/EditProfileForm.vue'
  import UserCard from './UserProfile/UserCard.vue'
  import MembersCard from './UserProfile/MembersCard.vue'

  export default {
    components: {
      EditProfileForm,
      UserCard,
      MembersCard
    }
  }

</script>
<style>

</style>
